export const TEST_ID = 'itemCardText';
